function drawingDateLabel(date,now=Date.now()){
 if(!/^\d{4}-\d{2}-\d{2}$/.test(date||''))return 'Date unavailable';
 const today=new Intl.DateTimeFormat('en-CA',{timeZone:'America/New_York',year:'numeric',month:'2-digit',day:'2-digit'}).format(now),days=Math.round((Date.parse(today)-Date.parse(date))/86400000);
 return (days===0?'Today':days===1?'Yesterday':days>1?days+' days ago':'Upcoming')+' · '+date;
}
module.exports={drawingDateLabel};
